// extracted by mini-css-extract-plugin
module.exports = {"container":"Share_container__3A4Eo","title":"Share_title__1q-YD","buttons":"Share_buttons__y07GV","shareButton":"Share_shareButton__3Wjsz"};